var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.inView)?_c('div',{style:(`height: ${_vm.itemHeight}px;`)}):(_vm.clickableItems)?_c('v-list-item',{on:{"click":function($event){return _vm.$emit('itemClick', _vm.item)}}},[_vm._t("item",null,{"item":_vm.item})],2):_c('v-list-item',[_vm._t("item",null,{"item":_vm.item})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }